import { FC } from "react";
import { StyledSocialLinksList } from "../styledComponents";
import { IconButton } from "@kaltura/ds-react-components";
import clsx from "clsx";
import { translate } from "@kaltura/mediaspace-shared-utils";
import SocialLinksFactory, { SocialType } from "./SocialLinksFactory";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";

export interface SocialLink {
    url?: string;
    type: SocialType;
}
interface SocialLinksProps {
    socialLinks?: SocialLink[];
    className?: string;
    iconButtonClassName?: string;
}

const SocialTitle: Record<SocialType, string> = {
    twitter: translate("Follow us on X"),
    facebook: translate("Follow us on Facebook"),
    linkedin: translate("Connect with us on LinkedIn"),
    youtube: translate("Subscribe to our YouTube Channel"),
    instagram: translate("Follow us on Instagram"),
    twitch: translate("Watch us on Twitch"),
    slack: translate("Follow us on Slack"),
    tiktok: translate("Follow us on tiktok"),
    line: translate("Follow us on line"),
};

/**
 * SocialLinks component - renders a list of social links as icon buttons
 * @param socialLinks
 * @param className
 * @param iconButtonClassName
 */
const SocialLinks: FC<SocialLinksProps> = ({ socialLinks, className, iconButtonClassName }) => {
    const sendButtonAnalytics = useButtonAnalytics();
    const sendAnalytics = (actionName: string) => {
        sendButtonAnalytics(actionName, ButtonClickAnalyticsType.NAVIGATE);
    };

    return (
        <StyledSocialLinksList className={className}>
            {!!socialLinks
                && socialLinks?.map((socialLink, index) => (
                    <li key={index}>
                        <IconButton
                            className={clsx(iconButtonClassName, socialLink.type)}
                            key={socialLink.url + socialLink.type}
                            component={"a"}
                            href={socialLink.url}
                            title={SocialTitle[socialLink.type]}
                            target={"_blank"}
                            rel={"noopener noreferrer"}
                            onClick={() => {
                                sendAnalytics(`Footer - Social Link - ${socialLink.type}`);
                            }}
                        >
                            <SocialLinksFactory linkType={socialLink.type} />
                        </IconButton>
                    </li>
                ))}
        </StyledSocialLinksList>
    );
};

export default SocialLinks;
